import "../styles.css";
import React, { memo, useEffect } from "react";
import { compose } from "redux";
import { connect, useDispatch } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  clearData,
  createInitialOrder,
  fetchReferralCode,
  setData,
  changeFormField,
  getJumioSessionToken
} from "ducks/actions";
import {
  makeSelectIsFetchingData,
  makeSelectOrderParams,
  makeSelectPayMonthlyItems,
  makeSelectPayTodayItems,
  makeSelectDeliveryDetailsItems,
  makeSelectReferralCode,
  makeSelectPaymentRequest,
  makeSelectOrderSummaryForm,
  makeSelectOrderSummaryFormInitialValues,
  makeSelectOrderSummaryPayload,
  makeSelectESigned,
  makeSelectPaymentModes,
  makeSelectDefaultPlanAddons,
  makeSelectFormattedSelectedNumber,
  makeSelectAddons,
  makeSelectPlanDetails,
  makeSelectDefaultPromoCodeOffers,
  makeSelectSessionToken,
  makeSelectIosDevice,
  makeSelectJumioRedirectUrl,
  makeSelectSadOrderParams,
  makeSelectOrder,
  makeSelectSimCount,
  makeSelectJumioData,
  makeSelectJumioSessionToken,
  makeSelectValidateIccId,
  makeSelectEKYCMessageData,
  makeSelectMyInfo,
  makeSelectMyInfoIsUsed,
  makeSelectMyInfoDetails,
  makeSelectSignPass,
  makeSelectJumioIsUsed,
  makeSelectGuestOrder,
  makeSelectIsWalletPromoCode,
  makeSelectEkycValidation,
  makeSelectMyInfoIsInvalid,
  makeSelectAppSettings,
} from "ducks/selectors";
import SmartRender from "containers/SmartRender";
import forEach from "lodash/forEach";
import {
  gotoUrl,
  setMyInfoFieldToClear,
  urlParam,
  buildStoredJumioAuthHeaders,
} from "utils/helpers";
import {
  forms,
  SIM_TYPES,
} from "utils/constants";
import { makeSelectAccountBillingDetails, makeSelectAccountPrimaryDetails, makeSelectAccountSecondaryDetails, makeSelectCompanyDetails, makeSelectIsSimTypeEsim, makeSelectIsTermsAndConditionAccept, makeSelectSimCountNewAndTransfer } from "ducks/selectors/planService";
import { createEnterpriseWorkFlow, fetchPaymentRequest } from "ducks/actions/index";
import { getRequestId } from "utils/localStorage";
import { get } from "lodash";

const ReviewOrderHOC = Component =>
  function Comp(props) {
    const {
      isSimTypeEsim,
      planDetails,
      simCounts,
      companyDetails,
      accountBillingDetails,
      accountPrimaryDetails,
      accountSecondaryDetails,
      createInitialOrder,
      createEnterpriseWorkFlow: callCreateEnterpriseWorkFlow,
      clearEditParams,
      isTermsAndConditionAccept,
      orderParams,
      order,
      myInfoDetails,
      referralCode,
      addons
    } = props
    const dispatch = useDispatch();
    useEffect(() => {
      if (urlParam("reset")) {
        gotoUrl('/enterprise/automated-onboarding?reset=true')
      }
      if(simCounts?.totalSimCount === 0){
        gotoUrl("/enterprise/automated-onboarding?reset=true")
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const { order_ref} = order || "";
    useEffect(() => {
      if(order_ref){
        const headersValue = buildStoredJumioAuthHeaders();
        const payload = {
          workflow: "payment_request",
          request_id: getRequestId(),
          status: "success",
          metadata: {
            order_ref:order_ref
          }
        };
        callCreateEnterpriseWorkFlow(headersValue,payload, () => {})
      }
      // eslint-disable-next-line
    },[order_ref])

    const reviewOrderWorkFlow = () =>{
      if(getRequestId()){
        const headersValue = buildStoredJumioAuthHeaders();
        const payload = {
          workflow: "review_order",
          request_id: getRequestId(),
          status: "success",
          metadata: {
            primary_account: {
              name: accountPrimaryDetails?.name || "",
              email: accountPrimaryDetails?.email || "",
              mobile: accountPrimaryDetails?.mobile_no || ""
            },
            secondary_account: {
              name: accountSecondaryDetails?.name || "",
              email: accountSecondaryDetails?.email || "",
              mobile: accountSecondaryDetails?.mobile_no || ""
            },
            billing_email_address: accountBillingDetails || ""
          }
        };
        callCreateEnterpriseWorkFlow(headersValue, payload, () => {});
      }
    }

    const disableIsTermsAndCondition = (isTermsAndConditionAccept) =>{
      dispatch(
        setData({
          key: "isTermsAndConditionAccept",
          data: { isTermsAndConditionAccept }
        })
      );
    }

    useEffect(() => {
      disableIsTermsAndCondition(false)
      clearEditParams()
      reviewOrderWorkFlow()
      // accountHolderWorkFlow()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    // const multiplier = simCounts?.totalSimCount >= 1 ? simCounts.totalSimCount : 1;
    const baseSummary = orderParams?.order_summary || {};
    const enterpriseOrderSummary = {
        subscription_plan_fee: (baseSummary.subscription_plan_fee || 0),
        subscription_addon_fee: (baseSummary.subscription_addon_fee || 0),
        subscription_total_fee: (baseSummary.subscription_total_fee || 0),
        delivery_slot_fee: baseSummary.delivery_slot_fee || 0,
        onetime_sim_activation_fee: (baseSummary.onetime_sim_activation_fee || 0),
        onetime_number_fee: (baseSummary.onetime_number_fee || 0),
        onetime_referral_code_discount_fee: (baseSummary.onetime_referral_code_discount_fee || 0),
        onetime_total_fee: (baseSummary.onetime_total_fee || 0)
    };

    const enterpriseOrderPayload = {
      channel_name: "enterprise_plan",
      sim_type: isSimTypeEsim ? SIM_TYPES.E_SIM: SIM_TYPES.PHYSICAL_SIM,
      number_type: "NEW",
      msisdn_source: "",
      selected_planid: planDetails?.sku,
      block_incoming_international_calls: false,
      block_incoming_international_sms: false,
      payment_type: "upfront",
      refferal_code: get(referralCode, "value") || "",
      id_upload_pending: false,
      dvs_id: "",
      plan_source: "DEFAULT",
      order_items: (addons || [])
        .filter(addon => addon.selected)
        .map(addon => ({
          sku: addon.id,
          price: addon.value,
          title: addon.label,
          name: addon.label,
          item_type: "ADDON",
          pay_monthly: addon.value,
          pay_now: 0,
          quantity: 1
        })),
      referral_detail: {
          referral_code: get(referralCode, "value") || "",
          is_valid: referralCode.valid || false
      },
      myinfo_log_id: myInfoDetails?.myinfo_log_id || "",
      documents: {
          doc_id: myInfoDetails?.myinfo_log_id || "",
          details: [
              {
                  doc_id: myInfoDetails?.myinfo_log_id || "",
                  doc_type: "nric",
                  category: "primary",
                  value: companyDetails?.uen || ""
              }
          ]
      },
      billing_detail: {
        email: accountBillingDetails || "",
        address: companyDetails?.company_address || ""
      },
      user_detail: {
          first_name: accountPrimaryDetails?.name,
          email: accountPrimaryDetails?.email,
          country_code: "+65",
          phone_number: accountPrimaryDetails?.mobile_no,
          dob: get(myInfoDetails, "dob.value"),
      },
      secondary_user_detail: {
        name: accountSecondaryDetails?.name,
        email: accountSecondaryDetails?.email,
        mobile_no: accountSecondaryDetails?.mobile_no,
      },
      order_summary: enterpriseOrderSummary,
      phone_only: false,
      order_wallet_payments_attributes: [
          {}
      ],
      enterprise_detail: {
          uen: companyDetails?.uen || "",
          company_name: companyDetails?.company_name || "",
          company_address: companyDetails?.company_address || "", 
          sim_type: isSimTypeEsim ? SIM_TYPES.E_SIM: SIM_TYPES.PHYSICAL_SIM,
          billing_email: accountBillingDetails || "",
          new_number_count: simCounts?.newSimCount,
          port_in_number_count: simCounts?.transferSimCount,
          total_lines_count: simCounts?.totalSimCount,
          flow_version: "v2"
      },
      re_captcha_token: "[PLACEHOLDER FOR TOKEN]"
  }
    console.log("ORDER PAYLOAD ",enterpriseOrderPayload)
    useEffect(() => {
      if(isTermsAndConditionAccept){
        createInitialOrder(enterpriseOrderPayload, result => {
          console.log("CREATE ORDER TEMP RESULT %#%%$%$%$%$%$%$%$%",result)
        })
      }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[isTermsAndConditionAccept])

    return <Component {...props} />;
  };

const mapStateToProps = createStructuredSelector({
  formValues: makeSelectOrderSummaryForm(),
  payload: makeSelectOrderSummaryPayload(),
  order: makeSelectOrder(),
  paymentRequest: makeSelectPaymentRequest(),
  orderParams: makeSelectOrderParams(),
  sadOrderParams: makeSelectSadOrderParams(),
  isCreatingOrder: makeSelectIsFetchingData("order"),
  isIosDevice: makeSelectIosDevice(),
  nextPage: makeSelectJumioRedirectUrl(),
  isFetchingPaymentRequest: makeSelectIsFetchingData("paymentRequest"),
  payMonthlyItems: makeSelectPayMonthlyItems(),
  payTodayItems: makeSelectPayTodayItems("OrderSummary"),
  deliveryDetailsItems: makeSelectDeliveryDetailsItems(),
  referralCode: makeSelectReferralCode(),
  eSigned: makeSelectESigned(),
  paymentModes: makeSelectPaymentModes(),
  initialValues: makeSelectOrderSummaryFormInitialValues(),
  selectedNumber: makeSelectFormattedSelectedNumber(),
  addons: makeSelectAddons(),
  defaultPlanAddons: makeSelectDefaultPlanAddons(),
  planDetails: makeSelectPlanDetails(),
  token: makeSelectSessionToken(),
  sim_count: makeSelectSimCount(),
  defaultPromoCodeOffers: makeSelectDefaultPromoCodeOffers(),
  isFetchingJumio: makeSelectIsFetchingData("jumio"),
  isFetchingJumioSessionToken: makeSelectIsFetchingData("jumioSessionToken"),
  validateIccid: makeSelectValidateIccId(),
  messageData: makeSelectEKYCMessageData(),
  myInfo: makeSelectMyInfo(),
  myInfoIsUsed: makeSelectMyInfoIsUsed(),
  myInfoDetails: makeSelectMyInfoDetails(),
  signPass: makeSelectSignPass(),
  jumioIsUsed: makeSelectJumioIsUsed(),
  jumioData: makeSelectJumioData(),
  jumioSessionToken: makeSelectJumioSessionToken(),
  jumioRedirectUrl: makeSelectJumioRedirectUrl(),
  guestOrder: makeSelectGuestOrder(),
  isWalletPromoCode: makeSelectIsWalletPromoCode(),
  ekycValidation: makeSelectEkycValidation(),
  myInfoIsInvalid: makeSelectMyInfoIsInvalid(),
  appSettings: makeSelectAppSettings(),
  simCounts: makeSelectSimCountNewAndTransfer(),
  isSimTypeEsim: makeSelectIsSimTypeEsim(),
  accountPrimaryDetails: makeSelectAccountPrimaryDetails(),
  accountSecondaryDetails: makeSelectAccountSecondaryDetails(),
  accountBillingDetails: makeSelectAccountBillingDetails(),
  companyDetails: makeSelectCompanyDetails(),
  isTermsAndConditionAccept: makeSelectIsTermsAndConditionAccept(),
});

export function mapDispatchToProps(dispatch) {
  return {
    createEnterpriseWorkFlow: (headersValue, params) => {
      dispatch(createEnterpriseWorkFlow(headersValue, params));
    },
    createInitialOrder: (orderParams, callback) => {
      dispatch(createInitialOrder(orderParams, callback));
    },
    getJumioSessionToken: (headers, params, callback) => {
      dispatch(getJumioSessionToken(headers, params, callback));
    },
    // getSignPassLinkUrl: (headersValue, params, callback) => {
    //   dispatch(getSignPassLinkUrl(headersValue, params, callback));
    // },
    validateReferralCode: (code, planName) => {
      dispatch(fetchReferralCode({ referral_code: code, plan_name: planName }));
    },
    clearMyInfoDomain: () => {
      dispatch(clearData("myInfoDetails"));
    },
    setMyInfoIsUsed: isUsed => {
      dispatch(
        setData({
          key: "myInfo",
          data: { isUsed }
        })
      );
      dispatch(
        changeFormField({
          form: forms.PERSONAL_DETAILS_FORM,
          field: "myInfoIsUsed",
          value: isUsed
        })
      );
    },
    changeField: (field, value) => {
      dispatch(
        changeFormField({
          form: forms.PERSONAL_DETAILS_FORM,
          field: field,
          value: value
        })
      );
    },
    clearAllMyInfoData: () => {
      dispatch(clearData("myInfoDetails"));
      dispatch(clearData("myInfo"));
    },
    resetReferralCode: () =>
      dispatch(clearData(["referralCode", "selectedAddons"])),
    clearPaymentRequest: () => {
      dispatch(clearData("paymentRequest"));
    },
    fetchPaymentRequest: params => {
      dispatch(fetchPaymentRequest(params));
    },
  };
}

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    clearMyInfoUrlParam: () => {
      gotoUrl(window.location.pathname, true, {
        code: null,
        state: null
      });
    },
    clearMyInfoFormFields: (fieldNameToClear = []) => {
      const changeField = dispatchProps.changeField;
      const fieldMap = setMyInfoFieldToClear(fieldNameToClear);
      forEach(fieldMap, fieldName => {
        changeField(fieldName, null);
      });
    },
     clearEditParams: () => {
      gotoUrl(window.location.pathname, true, {
        edit: null,
      });
    },
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);
export default compose(withConnect, memo)(ReviewOrderHOC(SmartRender));
